import React from 'react'

type ReloadIconProps = {
  width: number | string
  height: number | string
}

const ReloadIcon = ({ width, height }: ReloadIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 46 40"
  >
    <g fill="none">
      <path
        fill="#004083"
        d="M8.775 15.597L1.59 14.552c-1.174-.17-2.007 1.119-1.367 2.12l8.223 12.863c.455.712 1.437.857 2.077.302l11.552-9.987c.899-.777.467-2.249-.708-2.42l-7.012-1.02c1.884-5.162 6.828-8.864 12.636-8.864 7.423 0 13.461 6.035 13.461 13.455 0 7.419-6.038 13.453-13.46 13.453-1.532 0-2.775 1.242-2.775 2.773 0 1.532 1.243 2.773 2.774 2.773C37.473 40 46 31.477 46 21S37.473 2 26.99 2C18.387 2 11.11 7.747 8.775 15.597z"
      />
      <path
        fill="#FFF"
        d="M8.775 13.597L1.59 12.552c-1.174-.17-2.007 1.119-1.367 2.12l8.223 12.863c.455.712 1.437.857 2.077.302l11.552-9.987c.899-.777.467-2.249-.708-2.42l-7.012-1.02c1.884-5.162 6.828-8.864 12.636-8.864 7.423 0 13.461 6.035 13.461 13.455 0 7.419-6.038 13.453-13.46 13.453-1.532 0-2.775 1.242-2.775 2.773 0 1.532 1.243 2.773 2.774 2.773C37.473 38 46 29.477 46 19S37.473 0 26.99 0C18.387 0 11.11 5.747 8.775 13.597z"
      />
    </g>
  </svg>
)

export default ReloadIcon
